import { managementHero } from '@/mocks/expertsData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function ManagementHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={img('readdy/f1de128490fa9be5fabd8acc49d5bf7c.png')}
          alt="管理团队"
          className="w-full h-full object-cover object-top"
            fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 md:px-10">
        <ScrollReveal variant="fade-down">
          <p className="text-white/50 text-xs tracking-[0.3em] mb-4 font-medium uppercase">
            {managementHero.subtitle}
          </p>
        </ScrollReveal>
        <ScrollReveal variant="fade-up" delay={100}>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 leading-tight max-w-2xl whitespace-nowrap">
            {managementHero.title}
          </h1>
        </ScrollReveal>
        <ScrollReveal variant="fade-up" delay={200}>
          <p className="text-white/65 text-sm md:text-base max-w-xl leading-relaxed">
            {managementHero.description}
          </p>
        </ScrollReveal>
      </div>

    </section>
  );
}